module.exports = __webpack_public_path__ + "static/media/Housekeeper.445bace3.svg";